import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AutenticacionService } from './autenticacion.service';
import { PreguntaRespuesta } from '../_models/pregunta-respuesta';

@Injectable({
  providedIn: 'root'
})
export class RespuestaService {

  private rutServiciosRespuestas = AppSettings.rutServiciosAPL + '/api/respuestas/';

  constructor( private httpClient: HttpClient, private autenticacionService: AutenticacionService ) {
  }

  listado(): Observable<PreguntaRespuesta[]> {
    return this.httpClient.get( this.rutServiciosRespuestas ).pipe( map( res => res as PreguntaRespuesta[] ) );
  }

  listadoByPregunta( idPregunta: string ): Observable<PreguntaRespuesta[]> {
    return this.httpClient.get( this.rutServiciosRespuestas + 'byPregunta/' + idPregunta ).pipe( map( res => res as PreguntaRespuesta[] ) );
  }

  obtener( idRespuesta: string ): Observable<PreguntaRespuesta> {
    return this.httpClient.get( this.rutServiciosRespuestas + idRespuesta ).pipe( map( res => res as PreguntaRespuesta ) );
  }

  agregar( respuesta: PreguntaRespuesta ): Observable<PreguntaRespuesta> {
    respuesta.auditoriaUsuario = this.autenticacionService.obtenerIdUsuarioLogueado();
    respuesta.auditoriaFecha = new Date( Date.now() );
    return this.httpClient.post( this.rutServiciosRespuestas, respuesta ).pipe( map( res => res as PreguntaRespuesta ) );
  }

  actualizar( respuesta: PreguntaRespuesta ): Observable<any> {
    return this.httpClient.put( this.rutServiciosRespuestas, respuesta ).pipe( map( res => res ) );
  }

  bulk( respuestas: PreguntaRespuesta[] ) {
    const idUsuario = this.autenticacionService.obtenerIdUsuarioLogueado();
    respuestas.map( x => {
      x.auditoriaUsuario = idUsuario;
    } )
    return this.httpClient.post( this.rutServiciosRespuestas + 'bulk', respuestas ).pipe( map( res => res as any ) );
  }
}
